<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers />
			</el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!-- Page Header -->
							<div class="page_header">Search Change Requests</div>
				
							<div class="page_main">
								<el-form :model="query" label-position="top" class="search-form">
									<div class="form-grid">
										<!-- Left -->
										<div class="form-col">
											<el-form-item label="Request ID">
												<el-input v-model="query.id" placeholder="Please enter" clearable />
											</el-form-item>
				
											<el-form-item label="Status">
												<el-select v-model="query.status" class="full-width" placeholder="Please select">
													<el-option label="In Progress" value="1" />
													<el-option label="Approved" value="2" />
													<el-option label="Withdrawn" value="9" />
												</el-select>
											</el-form-item>
				
											<!-- <el-form-item label="Company">
												<div class="input-btn-group">
													<el-select
														v-model="query.company_id"
														placeholder="Please select"
														class="full-width"
														@change="getDepartment(query.company_id)"
														clearable>
														<el-option
															v-for="value in companyList"
															:key="value.id"
															:label="value.company_name"
															:value="value.id">
														</el-option>
													</el-select>
												</div>
											</el-form-item> -->
				
											<el-form-item label="Creation Date">
												<el-date-picker
													v-model="time"
													type="datetimerange"
													@change="getTime"
													range-separator="To"
													start-placeholder="Select start date"
													end-placeholder="Select end date"
													class="full-width"
													:default-time="['00:00:00', '23:59:59']">
												</el-date-picker>
											</el-form-item>
				
											<el-form-item label="Withdrawal Date">
												<el-date-picker
													v-model="time2"
													type="datetimerange"
													@change="getTime2"
													range-separator="To"
													start-placeholder="Select start date"
													end-placeholder="Select end date"
													class="full-width"
													:default-time="['00:00:00', '23:59:59']">
												</el-date-picker>
											</el-form-item>
										</div>
				
										<!-- Right -->
										<div class="form-col">
											<el-form-item label="Description">
												<el-input
													v-model="query.overall_description"
													placeholder="Please enter"
													clearable />
											</el-form-item>
				
											<el-form-item label="User">
												<div class="input-btn-group">
													<el-select
														filterable
														v-model="query.account"
														placeholder="Please select"
														class="full-width"
														clearable>
														<el-option
															v-for="value in userList"
															:key="value.id"
															:label="value.username"
															:value="value.id">
														</el-option>
													</el-select>
												</div>
											</el-form-item>
				
											<el-form-item label="Department">
												<div class="input-btn-group">
													<el-select
														v-model="query.departments_id"
														placeholder="Please select"
														class="full-width"
														clearable>
														<el-option
															v-for="value in departmentsList"
															:key="value.id"
															:label="value.departments_name"
															:value="value.id">
														</el-option>
													</el-select>
												</div>
											</el-form-item>
				
											<el-form-item label="Approval Date">
												<el-date-picker
													v-model="time1"
													type="datetimerange"
													@change="getTime1"
													range-separator="To"
													start-placeholder="Select start date"
													end-placeholder="Select end date"
													class="full-width"
													:default-time="['00:00:00', '23:59:59']">
												</el-date-picker>
											</el-form-item>
										</div>
									</div>
				
									<div class="search-btn-wrap">
										<el-button type="primary" @click="handleSearch">
											Search
										</el-button>
									</div>
								</el-form>
				
								<!-- Table -->
								<div class="table_box">
									<el-table
										:data="tableData"
										v-loading="tableloading"
										border
										class="table_el"
										header-cell-class-name="table-header"
										empty-text="No documents found in the change request">
										<el-table-column prop="request_id" label="Request ID" sortable />
										<el-table-column prop="overall_description" label="Description" sortable />
										<el-table-column prop="status" label="Status" sortable width="110">
											<template #default="scope">
												<div v-if="scope.row.status == 1">In Progress</div>
												<div v-if="scope.row.status == 2">Approved</div>
												<div v-if="scope.row.status == 9">Withdrawn</div>
											</template>
										</el-table-column>
				
										<el-table-column prop="username" label="User" sortable />
				
										<!-- <el-table-column prop="company_name" label="Company" sortable /> -->
				
										<el-table-column prop="departments_name" label="Department" sortable />
				
										<el-table-column prop="dateline" label="Creation Date" sortable />
				
										<el-table-column label="Approval Date" sortable>
											<template #default="scope">
												<div>{{ scope.row.pass_time || 'N/A' }}</div>
											</template>
										</el-table-column>
				
										<el-table-column label="Withdrawal Date" sortable>
											<template #default="scope">
												<div>{{ scope.row.withdraw_time || 'N/A' }}</div>
											</template>
										</el-table-column>
				
										<el-table-column prop="id" label="Action" width="80" align="center">
											<template #default="scope">
												<div class="inline_btn">
													<el-link
														type="primary"
														size="mini"
														@click="handleClick(scope.row)">
														Details
													</el-link>
												</div>
											</template>
										</el-table-column>
				
									</el-table>
				
									<div class="pagination">
										<el-pagination
											@size-change="handleSizeChange"
											@current-change="handlePageChange"
											:current-page="query.page"
											:page-sizes="[5, 10, 20, 50]"
											:page-size="query.page_size"
											layout="total, sizes, prev, pager, next"
											:total="pageTotal">
										</el-pagination>
									</div>
				
								</div>
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<!-- 选择人员弹窗 -->
		<UserSelect :visible.sync="userDialogVisible" :user-list="userList" :selected-id="selectedId"
			@confirm="handleConfirm" />
		<!-- 选择人员弹窗 -->
		<!-- loading -->
		<transition name="fade">
			<div class="loading" v-show="isLoading">
				<van-loading />
			</div>
		</transition>
	</div>
</template>

<script>
	import headers from "@/component/header.vue";
	import slider from "@/component/slider.vue";
	import UserSelect from "@/component/user-select.vue";
	import {
		resourcesLeixingList
	} from "@/api/docManage/configureDocControl/index";
	import {
		resourcesUpdateList
	} from "@/api/docManage/requestSearch/index";
	import {
		usersList
	} from "@/api/system/user";
	// import {
	// 	companyList
	// } from "@/api/system/company";
	import {
		departmentsList
	} from "@/api/system/department";
	import moment from "moment";
	moment.locale("zh-cn");

	export default {
		components: {
			headers,
			slider,
			UserSelect,
		},
		data() {
			return {
				isLoading: true,
				tableloading: false,
				query: {
					id: "",
					overall_description: "",
					status: "",
					account: "",
					// company_id: "",
					departments_id: "",
					leixing_id: "",
					page: 1,
					page_size: 10,
					dateline1: "",
					dateline2: "",
					pass_time1: "",
					pass_time2: "",
					withdraw_time1: "",
					withdraw_time2: "",
				},
				time: "",
				time1: "",
				time2: "",
				userName: "",
				selectedId: null,
				userDialogVisible: false,
				userList: [],
				// companyList: [],
				departmentsList: [],
				tableData: [],
				resourcesLeixingList: [],
				pageTotal: 0, //总条数
			};
		},
		created() {
			let that = this;
			that.getUserList();
		},
		mounted() {
			let that = this;
			that.isLoading = false;
			//请求文件类型
			resourcesLeixingList({
				page: 1,
				page_size: 9999,
				keyword: ""
			}).then(
				(res) => {
					if (res.code == 200) {
						//请求公司列表
						// companyList({
						// 	page: 1,
						// 	page_size: 9999,
						// 	status: 1,
						// 	company_name: "",
						// 	company_userid: "",
						// 	manage_userid: "",
						// }).then((res2) => {
						// 	if (res2.code == 200) {
								that.resourcesLeixingList = res.data.data;
								// that.companyList = res2.data.data;
								//请求部门列表
								that.getDepartment();
						// 	}
						// });
					}
				}
			);
		},
		watch: {
			//
		},
		methods: {
			getUserList() {
				let that = this;
				usersList({
					username: "",
					status: 1,
					page: 1,
					page_size: 999999,
				}).then((res) => {
					if (res.code == 200) {
						that.userList = res.data.data;
						that.isLoading = false;
					} else {

					}
				});
			},
			//请求部门列表
			getDepartment(val) {
				let that = this;
				that.query.departments_id = "";
				that.departmentsList = [];
				that.$toast.loading({
					duration: 0,
					forbidClick: true
				});
				departmentsList({
					page: 1,
					page_size: 9999,
					status: 1,
					departments_name: "",
					// company_id: value,
					departments_userid: "",
				}).then((res2) => {
					that.$toast.clear();
					that.departmentsList = res2.data.data;
					if (val) {
						that.query.departments_id = Number(val);
					}
				});
			},
			//时间格式化
			dateFormat: function(row, column) {
				let that = this;
				var date = row[column.property];
				if (date == undefined || date == 0) {
					return "/";
				}
				return moment(date * 1000).format("YYYY-MM-DD");
			},
			//时间选择变化
			getTime(date) {
				let that = this;
				if (date) {
					that.query.dateline1 = moment(date[0]).format("YYYY-MM-DD HH:mm:ss");
					that.query.dateline2 = moment(date[1]).format("YYYY-MM-DD HH:mm:ss");
				} else {
					that.query.dateline1 = "";
					that.query.dateline2 = "";
				}
			},
			getTime1(date) {
				let that = this;
				if (date) {
					that.query.pass_time1 = moment(date[0]).format("YYYY-MM-DD HH:mm:ss");
					that.query.pass_time2 = moment(date[1]).format("YYYY-MM-DD HH:mm:ss");
				} else {
					that.query.pass_time1 = "";
					that.query.pass_time2 = "";
				}
			},
			getTime2(date) {
				let that = this;
				if (date) {
					that.query.withdraw_time1 = moment(date[0]).format(
						"YYYY-MM-DD HH:mm:ss"
					);
					that.query.withdraw_time2 = moment(date[1]).format(
						"YYYY-MM-DD HH:mm:ss"
					);
				} else {
					that.query.withdraw_time1 = "";
					that.query.withdraw_time2 = "";
				}
			},
			getTableData() {
				let that = this;
				that.tableloading = true;
				resourcesUpdateList(that.query).then((res) => {
					that.tableloading = false;
					that.tableData = res.data.data;
					that.pageTotal = res.data.total;
					that.isLoading = false;
				});
			},
			openUserDialog() {
				let that = this;
				that.userDialogVisible = true;
			},
			handleSearch() {
				let that = this;
				that.query.page = 1;
				that.getTableData();
			},
			//清空搜索项
			clearSearch() {
				let that = this;
				that.query = {
					id: "",
					overall_description: "",
					status: "",
					account: "",
					// company_id: "",
					departments_id: "",
					leixing_id: "",
					page: 1,
					page_size: 10,
					dateline1: "",
					dateline2: "",
					pass_time1: "",
					pass_time2: "",
					withdraw_time1: "",
					withdraw_time2: "",
				};
				that.getTableData();
			},
			//条数选择
			handleSizeChange(value) {
				let that = this;
				that.query.page_size = value;
				that.getTableData();
			},
			//页数跳转
			handlePageChange(value) {
				let that = this;
				that.query.page = value;
				that.getTableData();
			},
			handleConfirm({
				id,
				user
			}) {
				let that = this;
				that.selectedId = id || null;
				that.query.account = id;
				that.userName = user ? user.username : "";
			},
			handleClick(value) {
				let that = this;
				const routeData = that.$router.resolve({
					path: "/DocControl/reviewChangeRequest",
					query: {
						id: value.id
					},
				});
				window.open(routeData.href, "_blank");
			},
			//跳转页面
			goUrl(url) {
				let that = this;
				that.$router.push(url);
			},
		},
	};
</script>

<style lang="less" scoped>
	//主要内容
	.main_main {
		.page_main {
			padding: 18px 20px;

			.btn_el {
				margin: 10px 0 20px 0;

				.tips {
					padding: 6px 8px;
					background-color: #ffb1001a;
					border-radius: 6px;
					font-size: 16px;
					font-weight: bold;
				}
			}
		}

		//页头
		.page_header {
			padding: 0 20px;
			height: 60px;
			line-height: 60px;
			background-color: #d8e4f0;
			font-size: 24px;
			font-weight: bold;
			box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
		}
	}
</style>
<style scoped>
	.main_box {
		height: calc(100vh - 60px);
		overflow-y: auto;
	}

	.main_box .main_main {
		position: relative;
		min-height: calc(100% - 0px);
		max-height: auto;
		background-color: #fafafa;
	}

	.el-header,
	.el-main {
		padding: 0;
	}

	.form-grid {
		display: grid;
		grid-template-columns: 1fr 1fr;
		grid-column-gap: 24px;
		align-items: start;
	}

	.form-grid .el-form-item {
		margin-bottom: 0;
	}

	.form-grid {
		display: grid;
		grid-template-columns: 1fr 1fr;
		grid-column-gap: 24px;
		align-items: start;
	}

	.full-width {
		width: 100%;
	}

	.input-btn-group {
		display: flex;
		align-items: center;
		gap: 10px;
	}

	.input-btn-group .el-input {
		flex: 1;
	}

	.search-btn-wrap {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 20px 0 16px;
	}

	.inline_btn {
		display: inline-block;
	}

	.table_box {
		width: 100%;
	}

	.table_box .inline_btn {
		display: inline-block;
	}

	.table_box .pagination {
		margin: 10px 0;
		text-align: right;
	}

	.table_box .mr_l {
		margin-left: 10px;
	}

	.pagination {
		margin: 10px 0;
		text-align: right;
	}

	::v-deep .el-form-item__label {
		padding-bottom: 6px;
		color: #303133;
		font-weight: 600;
	}

	::v-deep .el-input__inner,
	::v-deep .el-textarea__inner {
		border-radius: 4px;
	}

	@media (max-width: 1200px) {
		.form-grid {
			grid-template-columns: 1fr;
		}
	}

	::v-deep .el-button {
		border-radius: 6px;
	}

	::v-deep .btn span {
		text-decoration: underline;
	}

	::v-deep .form-grid .el-form-item__label {
		padding-bottom: 0;
	}
</style>